import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import CustomTabs from "components/tabs/customTab";
import OverdueCard from "./OverdueCard";
import LeaveRequestsCard from "./LeaveRequestsCard";
import TasksCard from "./TasksCard";
import { Badge } from "antd";
import DueSoonCard from "./DueSoonCard";

const ActionTabs = ({leaveCount, overdueCount, dueSoonCount, tasksCount}) => {
  const [activeTab, setActiveTab] = useState("all");
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#action-required") {
      setActiveTab("all");
    }
  }, [location.hash]);
  
  const allCount = overdueCount + leaveCount + dueSoonCount + tasksCount;
  const invoicesCount = overdueCount + dueSoonCount; 
  const TabLabel = ({ text, count, color }) => (
    <div className="flex items-center justify-center gap-2">
      <span className="text-sm font-medium">{text}</span>
      <Badge
        count={count}
        size="small"
        style={{
          backgroundColor: color,
          fontSize: "9px",
        }}
      />
    </div>
  );

  const tabOptions = [
    { label: <TabLabel text="All" count={allCount} color="rgb(251 44 54)" />, value: "all" }, 
    { label: <TabLabel text="Leaves" count={leaveCount} color="rgb(251 44 54)" />, value: "leaves" }, 
    { label: <TabLabel text="Invoices" count={invoicesCount} color="rgb(255 105 0)" />, value: "invoices" }, 
    { label: <TabLabel text="Tasks" count={tasksCount} color="rgb(139 92 246)" />, value: "tasks" }, 
  ];

  return (
    <div className="flex flex-col gap-4">
      <CustomTabs
        tabs={tabOptions}
        height="h-9"
        activeTab={activeTab}
        onChange={setActiveTab}
      />

      <div className="mt-3 space-y-4">
        {activeTab === "all" && (
          <>
            <OverdueCard />
            <LeaveRequestsCard />
            <DueSoonCard />
            <TasksCard />
          </>
        )}
        {activeTab === "leaves" && <LeaveRequestsCard />}
        {activeTab === "invoices" && (
          <>
            <OverdueCard />
            <DueSoonCard />
          </>
        )}
        {activeTab === "tasks" && <TasksCard />}
      </div>
    </div>
  );
};

export default ActionTabs;
